import styled, { css } from "styled-components";
import { Flex, LinearProgress, Description, IconButton, transition } from "@evergis/ui";

export const AttributeGalleryContainer = styled.div`
  && {
    width: calc(100% + 3rem);
  }

  min-height: 12.625rem;
  background-color: ${({ theme: { palette } }) => palette.element};

  img {
    width: 100%;
  }
`;

export const LinearProgressContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  min-height: inherit;

  ${LinearProgress} {
    max-width: 4rem;
  }
`;

export const NoLiveSnapshotContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;

  span[kind="alert"] {
    width: 2rem;
    height: 2rem;

    &:after {
      font-size: 2rem;
      color: ${({ theme: { palette } }) => palette.elementDeep};
    }
  }

  ${Description} {
    font-size: 0.75rem;
    color: ${({ theme: { palette } }) => palette.textDisabled};
  }
`;

export const SmallPreviewControl = styled(IconButton)<{ $isDisabled?: boolean }>`
  cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};
  z-index: 3;
  position: absolute;
  top: 50%;
  width: 2.5rem;
  height: 2.5rem;
  margin-top: -1.25rem;
  background-color: rgba(61, 61, 61, 0.8);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};

  span:after {
    color: ${({ $isDisabled }) => ($isDisabled ? "rgba(255, 255, 255, 0.28)" : "rgba(255, 255, 255, 1)")};
    transition: color ${transition.hover};
  }
`;

export const SmallPreviewCounter = styled(Flex)`
  z-index: 3;
  position: absolute;
  bottom: 0.625rem;
  left: 0;
  width: 100%;
  height: 1rem;
  justify-content: center;

  > div {
    background-color: rgba(61, 61, 61, 0.8);
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.medium};
    padding: 0 0.5rem;
    font-size: 0.625rem;
    line-height: 1rem;
    color: #fff;
  }
`;

export const SmallPreviewLeft = styled(SmallPreviewControl)`
  left: 1.5rem;
`;
SmallPreviewLeft.defaultProps = { kind: "prev" };

export const SmallPreviewRight = styled(SmallPreviewControl)`
  right: 1.5rem;
`;
SmallPreviewRight.defaultProps = { kind: "next" };

const imgSlideShowMixin = css<{ currentIndex?: number; prevIndex?: number }>`
  &:nth-child(${({ prevIndex }) => prevIndex}) {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;

    animation-duration: 0.25s;
    animation-name: fadeOut;
    animation-timing-function: linear;

    @keyframes fadeOut {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }
  }
`;

export const SmallPreviewContainer = styled.div<{ onClick?: VoidFunction; currentIndex?: number; prevIndex?: number }>`
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  position: relative;
  width: 100%;
  height: 100%;
  min-height: inherit;
  line-height: 0;

  ${LinearProgress} {
    z-index: 3;
    position: absolute;
  }

  ${SmallPreviewControl}, ${SmallPreviewCounter} {
    opacity: 0;
    transition: opacity ${transition.hover};
  }

  &:hover {
    ${SmallPreviewControl}, ${SmallPreviewCounter} {
      opacity: 1;
    }
  }

  img {
    z-index: 0;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: inherit;
    object-position: center;
    object-fit: cover;

    &:nth-child(${({ currentIndex }) => currentIndex}) {
      z-index: 1;
    }

    ${({ prevIndex, currentIndex }) => prevIndex !== currentIndex && imgSlideShowMixin}
  }
`;

export const SmallPreviewImages = styled.div``;
